import React, { useState, useEffect } from 'react';

import { toastr } from 'react-redux-toastr';

import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BotsCreators } from '../../store/actions/bots';
import { UserActions } from '../../store/actions/users';

import './SelectSector.css';
import logo from '../../assets/images/logo-code7-boteria.svg';
import InputDropdown from '../../bergmannsoft/components/Widgets/Forms/InputDropdown';

function SelectSector(props) {
  const { user, selectOrganization, me, history } = props;
  const [retry, setRetry] = useState(0);

  const [organizations, setOrganizations] = useState([]);
  const [organization, setOrganization] = useState(null);
  const [valueSelect, setValueSelect] = useState('');

  useEffect(() => {
    if (retry < 3) {
      if (user?._id) {
        updateOrganizations();
        user.organizations
          .map((i) => {
            setValueSelect(i.name);
          })
          .join(', ');
      } else {
        me();
        setRetry((retry) => retry + 1);
      }
    }
  }, [user]);

  const selectOrganizationChange = (organization) => {
    selectOrganization(organization._id);
  };

  const updateOrganizations = () => {
    if (
      user &&
      user.organizations &&
      user.organizations.length > 0 &&
      organizations.length < 1 &&
      !organization
    ) {
      const selectedOrg = user.organizations.find(
        (i) => i._id === user.selectedOrganization
      );
      setOrganizations(user.organizations);
      setOrganization(selectedOrg);
    }
  };

  const sectorEnter = () => {
    if (organization.name && organization.name !== '') {
      history.push('/video');
    } else {
      toastr.error('Erro', 'Selecione um setor');
    }
  };
  return (
    <div className="container-select-sector">
      <Link to="/">
        <img
          alt="Logo"
          src={logo}
          style={{ marginTop: 72, marginBottom: 50 }}
        />
      </Link>
      <div className="box-select-sector">
        <div className="box-auth__title">Seja bem-vindo!</div>
        <p className="info-select-sector">
          Sua conta possui mais de um setor cadastrado. Selecione a que deseja
          acessar:
        </p>

        <InputDropdown
          className="input-select-setor"
          value={organization ? organization.name : ''}
          placeholder={organization ? organization.name : ''}
          dropdownItemsList={organizations}
          onChange={(value) => {
            selectOrganizationChange(value);
          }}
          styleWidth="100%"
        />

        <div className="container-footer-select-sector">
          <button onClick={sectorEnter}>entrar</button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions, ...BotsCreators }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SelectSector)
);
